import styles from "./Memo.module.css";

type Props = {};

export const Memo = (props: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>Memo</div>
        <ul>
          <li>Please pay via PayPal.</li>
          <li>Invoices are sent prior to delivery.</li>
          <li>No additional fees are required for commercial use.</li>
          <li>
            Regardless of the request, the work will take about one month.
          </li>
          <li>
            Please allow me to post your work on my page. If you prefer your
            work to remain private or have a specific date when it can be made
            public, please let me know via the request form.
          </li>
          <li>
            One request may be submitted per application. Should you wish to
            submit multiple requests, please complete the request procedure and
            then register your email address again to receive the request form
            URL.
          </li>
          <li>
            After commission acceptance resumes, the deadline will be announced
            via the request form. For urgent requests during the suspension
            period, please contact us directly.
          </li>
        </ul>
      </div>
    </div>
  );
};
